module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"started_subscription_purchase","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24}},"required":["user"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/started_subscription_purchase.json
// module id = 581
// module chunks = 100